module.exports = __webpack_public_path__ + "img/competencies_swiper_08.e3538ae7.jpg";